import React, { Component } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { translate } from 'react-i18next';

import Heading from '../elements/PageHeading';
import Paragraph from '../elements/Paragraph';
import QRScanner from '../elements/QRScanner';
import Button from '../elements/Button';
import theme from '../../theme';

const ScanError = styled.div`
  padding: 10px;
  text-align: center;
  color: ${theme.danger};
`;

const LineBreak = styled.div`
  display: flex;
  align-items: center;
  margin: 30px 0;
`;

const Line = styled.span`
  flex-grow: 1;
  height: 1px;
  background-color: #28b6ea;
  margin: 0 15px;
`;

const Heading2Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #28b6ea;
  font-weight: bold;
  text-align: center;
  min-height: 30px;
`;

const Heading2 = styled.span`
  vertical-align: middle
  font-size: 40px;
  line-height: 48px;
  white-space: pre-line;
`;

const InputWrapper = styled.div`
  position: relative;
  overflow: visible;
  text-align: center;
  margin-bottom: 37px;
`;

const Input = styled.input`
  box-sizing: border-box;
  width: 360px;
  height: 50px;
  border: solid 1px #28b6ea;
  font-size: 14px;
  margin: 37px 0px 20px;
  padding: 0px 20px;
`;

class ErrorPage extends Component {
  state = { error: '', deviceId: '' };

  handleInputChange = event => {
    this.setState({ deviceId: event.target.value });
  };

  handleSubmit = event => {
    event.preventDefault();
    const baseURL = window.location.origin + '/';
    const modifiedURL = `${baseURL}${encodeURIComponent(this.state.deviceId)}`;
    window.location.href = modifiedURL;
  };

  render() {
    const { t, title, hint, history, showDeviceInput = true } = this.props;
    return (
      <React.Fragment>
        <Heading text={t(title)} />
        {hint ? (
          <Paragraph style={{ marginTop: '26px', marginBottom: '56px' }}>
            {t(hint)}
          </Paragraph>
        ) : null}
        {showDeviceInput ? (
          <>
            <LineBreak>
              <Line />
            </LineBreak>
            <QRScanner
              onScan={result => {
                try {
                  const target = new URL(result);
                  if (target.origin === window.location.origin) {
                    history.push({ pathname: target.pathname });
                  } else {
                    this.setState({
                      error: 'errors.qr_scan_no_deviceid',
                    });
                  }
                } catch (e) {}
              }}
            />
            <ScanError>{t(this.state.error)}</ScanError>
            <LineBreak>
              <Line />
              <span style={{ color: '#28b6ea', fontWeight: 'bold' }}>OR</span>
              <Line />
            </LineBreak>
            <Heading2Container>
              <Heading2>Enter device ID</Heading2>
            </Heading2Container>
            <InputWrapper>
              <Input
                value={this.state.deviceId}
                onChange={this.handleInputChange}
              />
              <Button onClick={this.handleSubmit}>{t('button.submit')}</Button>
            </InputWrapper>
          </>
        ) : null}
      </React.Fragment>
    );
  }
}

export default withRouter(translate()(ErrorPage));
